import Validator from 'validatorjs'
import { str2digits } from 'src/utils/util'
import _ from 'lodash'

export default {
  /**
   * Register the custom validation rules
   */
  created () {
    Validator.register('gte', (val, req, attr) => {
      return _.gte(parseInt(val),
                   parseInt(req))
    }, ':attr has surpassed the max number of rows allowed')

    Validator.register('range', (val, req, attr) => {
      let n = parseInt(val)
      let [min, max] = req.split(',')
      return _.gte(n, min) && _.lte(n, max)
    }, ':attr has surpassed the max number of rows allowed')

    Validator.register('before_or_equal', (val, req, attr) => {
      var val1 = req
      var val2 = val
      if (new Date(val1).getTime() >= new Date(val2).getTime()) {
        return true
      }
      return false
    }, ':attr has surpassed the max number of rows allowed')

    Validator.register('after_or_equal', (val, req, attr) => {
      var val1 = req
      var val2 = val
      if (new Date(val1).getTime() <= new Date(val2).getTime()) {
        return true
      }
      return false
    }, ':attr has surpassed the max number of rows allowed')

    /**
     * Calculate the maximum amount of 'rows' within a textarea.
     * Simply count the amunt of \n's in the value
     */
    Validator.register('maxrows', (value, requirement, attribute) => {
      const match = String(value).match(/\n/g)
      return match === null || (match.length) < requirement
    }, ':attribute has surpassed the max number of rows allowed')
    /**
     * Make sure a date is after this the value given.
     */
    Validator.register('after', (value, requirement, attribute) => {
      const after = new Date(requirement).getTime()
      const val = new Date(value).getTime()
      return val > after
    }, ':attribute must be a date after :value')
    /**
     * Make sure the date is before the given value
     */
    Validator.register('before', (value, requirement, attribute) => {
      const before = new Date(requirement).getTime()
      const val = new Date(value).getTime()
      return val < before
    }, ':attribute must be a date before :value')
    /**
     * Make sure the date is before the given value
     */
    Validator.register('date', (value, requirement, attribute) => {
      let vdate = new Date(value)
      return vdate.toString() !== 'Invalid Date'
    }, ':attribute must be a valid date')
    /**
     * Validate a telephone number.
     * As i didnt really want to pull in any massive validation libraries i just
     * did a little RegEx magic to just match against whitespace,+,-,(,),0-9 this should
     * cover nearly all eventualities.
     */
    Validator.register('telephone', (value, requirement, attribute) => {
      return /^[0-9()-\s\+]+$/gm.exec(value) !== null
    }, ':attribute must be a valid telephone number')

    Validator.register('accepted', (v, r, a) => v, ':attribute must be accepted')

    Validator.register('piped_regex', (val, req, attr) => {
      req = req.replace(/<%pipe_placholder%>/g, '|')
      var mod = /[g|i|m]{1,3}$/
      var flag = req.match(mod)
      flag = flag ? flag[0] : 'i'
      req = req.replace(mod, '').slice(1, -1)
      req = new RegExp(req, flag)
      return !!val.match(req)
    }, 'Please enter a valid UK postcode.')

    Validator.register('luhn', (v, r, a) => {
      let digits = str2digits(v)
      if (digits < 16) return false
      let sum = digits.reverse()
                      .reduce((s, d, i) => s + (i % 2 === 1 ? (d === 9 ? 9 : (d * 2) % 9) : d))
      return (sum % 10) === 0
    })

    Validator.register('minFiles', (v, r, a) => {
      return v.filter(x => !_.isEmpty(x)).length >= parseInt(r)
    })

    Validator.register('maxFileSizeMb', (v, r, a) => {
      let max = parseInt(r) * (1024 * 1024)
      return _.every(v.filter(x => !_.isEmpty(x)), x => x.size <= max)
    })
  },
  methods: {
    /**
     * Shared logic for components computed validation properties.
     */
    computedValidate (f, n) {
      let { validation, field } = f
      if (_.isEmpty(validation)) return null
      let {messages, rules} = _.reduce(validation,
                                   _.partial(this.parseRules, field),
                                   {messages: {}, rules: {}})
      const v = new Validator({[field]: n}, rules, messages)
      return v.fails() ? [v.errors.first(field)] : null
    },

    parseRules (field, acc, n) {
      let [type, {msg, rule}] = this.format(n)
      acc.messages[type] = msg
      acc.rules[field] = _.isNil(acc.rules[field]) ? rule : acc.rules[field].concat('|', rule)
      return acc
    },

    format (obj) {
      let [rule, exp] = obj.rule.split(':')
      return [rule,
             _.eq(rule, 'regex') ? this.parseRegex(rule, exp, obj) : obj]
    },

    parseRegex (rule, exp, src) {
      return _.includes(exp, '|') ? _.set(src, 'rule', `piped_${rule}:${exp.replace(/\|/g, '<%pipe_placholder%>')}`) : src
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/validate.js